import './AiAssistantAura.css';

import useAiAssistantAura from '../../hooks/useAiAssistantAura';
import AiAssistantAuraIcon from '../Icons/AiAssistantIcons/AiAssistantAuraIcon';

// The wrapper takes the caller's positioning and clip - the hook overwrites the inner transform every frame
const AiAssistantAura = ({className}) => {
    const auraRef = useAiAssistantAura();

    return (
        <div className={className}>
            <AiAssistantAuraIcon ref={auraRef} className='absolute inset-x-0 -bottom-1 origin-bottom' />
        </div>
    );
};

export default AiAssistantAura;
